import Markdown from 'markdown-to-jsx';
import {fetchAiTutorSessionDetailsRequest} from 'APIs/aiTutorAPI/session';
import {ChatResponse} from 'APIs/aiTutorAPI/chat/types';
import styles from './AiTutorReport.module.scss';

export interface AiTutorReportProps {
  title?: string;
  body?: string;
  sessionId?: number;
  report?: ChatResponse['report'];
}

function AiTutorReport({
  title,
  body,
  report,
  sessionId,
}: AiTutorReportProps): JSX.Element {
  const sessionDetails = fetchAiTutorSessionDetailsRequest(sessionId, {
    isPaused: () => !!report,
  });

  const totalPoints =
    report?.total ?? sessionDetails.data?.conversation_summary.total;

  return (
    <div className={styles.report}>
      <h2 className={styles.reportTitle}>
        <Markdown>
          {(title ?? '').replace('{{pontos}}', totalPoints?.toString() ?? '0')}
        </Markdown>
      </h2>
      <p className={styles.reportBody}>
        <Markdown>{body || ''}</Markdown>
      </p>
    </div>
  );
}

export default AiTutorReport;
